/** Whether a request URL should carry the operator's bearer token. Pure, and separate from the
 *  interceptor that applies it, for the same reason `shouldLogoutOn401` is. */
export default function needsAuthentication(url: string | undefined, apiBase: string): boolean {
  if (!url) return false
  if (apiBase) return url === apiBase || url.startsWith(`${apiBase}/`)
  // `//evil.example/x` starts with `/` but resolves to another origin.
  return url.startsWith('/') && !url.startsWith('//')
}
